import { createFileRoute } from '@tanstack/react-router';
import { BrandListPage } from '@/features/brand-research/BrandListPage';

export const Route = createFileRoute('/brands/')({
  component: BrandListPage,
});
